import React, { Component } from "react";
import StatsBox from "../Components/StatsPage/StatsBox.js";
import "./BasicPage.css";
import "./SubmitPage.css";
import axios from "../api/axios.js";
import Footer from "../Components/Footer.js";
import HomeNavbar from "../HomeNavbar.js";
import { useState, useRef, useEffect } from "react";
import SubmitInputField from "../Components/SubmitPage/submitInputField.js";
import ReactionForm from "../Components/SubmitPage/ReactionForm.js";
import groupSubstrates from "../functions/groupSubstratesSubmit.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import MechanismWindow from "../Components/MechanismTable/mechanismWindow.js";
import { renderMechanism } from "../api/renderMechanism.js";
import MechanismTable from "../mechanismTable.js";
import Creatable,  { useCreatable } from 'react-select/creatable';
import CreatableSelect from 'react-select/creatable';
import SubmitCreatableSelect from "../Components/SubmitPage/SubmitCreatableSelect.js";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth.js";
import { Buffer } from "buffer";

function SubmitPage() {

    const [formEnzymeData, setFormData] = useState({
        uniprotId: "",
        genbankId: "",
        martsId: "",
        enzymeName: "",
        aminoacidSequence: "",
        species: "",
        kingdom: "" 
      });
      const navigate = useNavigate();
      const isAutoFilling = useRef(false);
      const [isAutoFilled, setIsAutoFilled] = useState(false);
      const [reactions, setReactions] = useState([]);
      const [SubmitMessage, setSubmitMessage] = useState("");
      const [mechanismBody, setMechanismBody] = useState([]);
      const [mechanismStepTypes, setMechanismStepTypes] = useState([]);
      const [kingdoms, setKingdoms] = useState([]);
      const [evidenceTypes, setEvidenceTypes] = useState([]);
      const [maxMechanismSubmissions, setMaxMechanismSubmissions] = useState(0);
      const [knownConditionTags, setKnownConditionTags] = useState([]);
      const { auth } = useAuth();
      
      async function getIntitalCheck(){
        console.log("auth:", auth);
        const req = {
          requestType: "initialCheck"
        }
        const response = await axios.post("/submitcheck", req);
        setMechanismStepTypes(response.data.mechanism_types.map(value => ({ value, label: value })));
        setKingdoms(response.data.kingdoms.map(value => ({ value, label: value })));
        let evidence = response.data.evidence;
        evidence = evidence.filter(e => e != null);
        evidence = evidence.filter(e => e != "TRUE");
        setEvidenceTypes(evidence.map(value => ({ value, label: value })));
        setMaxMechanismSubmissions(response.data.maxMechSubID ? response.data.maxMechSubID : 0);
        setKnownConditionTags(response.data.knownConditionTags ? response.data.knownConditionTags : []);
      }
      useEffect(() => {
    
        getIntitalCheck();
      }, []);

      const handleInputChange = async (e) => {
        console.log(e)
        if (isAutoFilled) {
          setFormData({
            uniprotId: "",
            genbankId: "",
            martsId: "",
            enzymeName: "",
            aminoacidSequence: "",
            species: "",
            kingdom: ""
          });
          setReactions([]);
          setIsAutoFilled(false); 
          return;
        }
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
        
        const result = await checkDatabase(name, value);
        console.log(result);
        if (result) {
          isAutoFilling.current = true;
          setFormData({
            uniprotId: result.uniprotId,
            genbankId: result.genbankId,
            martsId: result.martsId,
            enzymeName: result.enzymeName,
            aminoacidSequence: result.aminoacidSequence,
            species: result.species,
            kingdom: result.kingdom
          });
          setIsAutoFilled(true);
          if (result.reactions){
          setReactions(result.reactions || []);
        } else {
          setReactions([]);
        }
          isAutoFilling.current = false;
        }
    };


    const addReaction = () => {
      let rea_yield = "minor"
      if (reactions.length == 0){
        rea_yield = "major"
      }
      setReactions([
        ...reactions,
        { type: "", class: "", substrates: [{smiles:"", name:"", marts:"", chebi:"", stereochemistry:"uncertain"}], product_mol: {smiles:"", name:"", marts:"", chebi:"", stereochemistry:"uncertain"}, publication: "", publicationdoi: "", isAutoFilled: false, is_new: true, mechanism_marts: null, mechanism_steps : [], final_mech_step: "", final_mech_evidence: "", mechanism_publication: "", mechanism_doi: "", conditionTags: "", abundance: rea_yield },
      ]);
    };

    const removeReaction = () => {
      if (reactions.length === 0 || reactions[reactions.length - 1].is_new === false) {
        return;
      }
      setReactions(reactions.slice(0, -1));
    };
  
    const handleReactionChange = (index, updatedReaction) => {
      setReactions(reactions.map((r, i) => (i === index ? updatedReaction : r)));
    };

    /*
     * Mechanisms already defined elsewhere in this form, offered to the
     * "Copy mechanism" dialog of reaction `currentIndex`. Reactions sharing a
     * substrate usually share the first steps too, so copying beats retyping.
     */
    const getSessionMechanismSources = (currentIndex) =>
      reactions
        .map((reaction, index) => ({ reaction, index }))
        .filter(({ reaction, index }) => index !== currentIndex && Array.isArray(reaction.mechanism) && reaction.mechanism.length > 0)
        .map(({ reaction, index }) => ({
          index,
          label: `Reaction ${index + 1}${reaction.product_mol?.name ? " to " + reaction.product_mol.name : ""}`,
          substrate: reaction.substrates[0],
          steps: reaction.mechanism,
          evidence: reaction.final_mech_evidence,
          publication: reaction.mechanism_publication,
          doi: reaction.mechanism_doi,
        }));
    
      
      async function checkDatabase(field, value) {
        console.log("Checking dtaabase {field, value}:", field, value);
        if (value == "") {
          return null
        }

        const req = {
          uniprotId: null,
          genbankId: null,
          martsId:  null,
          requestType: "enzyme"
        }
        if (field=="uniprotId"){
          if (!/^[OPQ][0-9][A-Z0-9]{3}[0-9]|[A-NR-Z][0-9]([A-Z][A-Z0-9]{2}[0-9]){1,2}$/.test(value)) {
            return null;
          }
          req.uniprotId = value
        }
        else if (field=="genbankId"){
          req.genbankId = value
        }
        else if (field=="martsId"){
          if (!/^marts_[ERM][0-9]{5}$/.test(value)) {
            return null;
          }
          req.martsId = value
        }
        else{
          return null
        }
        const response = await axios.post("/submitcheck", req);
        if (typeof response.data === 'object' && response.data !== null) {
          return {
              uniprotId: response.data.uniprot_id,
              genbankId: response.data.genbank_id,
              martsId: response.data.persistent_id,
              enzymeName: response.data.name,
              aminoacidSequence: response.data.aminoacid_sequence,
              species: response.data.species,
              kingdom: response.data.kingdom,
              reactions: groupSubstrates(response.data.reactions)
          }
      } else if (typeof response.data === 'string') {
          return null;
      }
        return null;
      }


       function checkIfSubmissionOk() {
        if (formEnzymeData.uniprotId == "" && formEnzymeData.genbankId == ""){
          return "Please enter a Uniprot ID or a Genbank ID";
        }
        if (formEnzymeData.enzymeName == ""){
          return "Please enter an enzyme name";
        }
        if (formEnzymeData.aminoacidSequence == ""){
          return "Please enter an amino acid sequence";
        }
        if (formEnzymeData.aminoacidSequence.length < 60){
          return "Amino acid sequence must be at least 60 characters long";
        }
        if (formEnzymeData.species == ""){
          return "Please enter a species";
        }
        if (formEnzymeData.kingdom == ""){
          return "Please enter a kingdom";
        }
        for (let i = 0; i < reactions.length; i++){
          if (reactions[i].is_new){
            if (!(["psy", "sqs","hemi", "mono", "sesq", "di", "tri", "sester", "pt", "tetra", "sesquar", "mero"].includes(reactions[i].type))){
              return "Please enter a correct type for reaction " + (i+1);
            }
            if (!(["1", "2"].includes(reactions[i].class))){
              return "Please enter either 1 or 2 as class for reaction " + (i+1);
            }
            if (reactions[i].publication == "" || reactions[i].publicationdoi == ""){
              return "Please enter a publication for reaction " + (i+1);
            }
            if (reactions[i].substrates.length == 0){
              return "Please enter at least one substrate for reaction " + (i+1);
            }
            for (let j = 0; j < reactions[i].substrates.length; j++){
              if (reactions[i].substrates[j].smiles == ""){
                return "Please enter a SMILES string for substrate " + (j+1) + " of reaction " + (i+1);
              }
            }
            if (reactions[i].abundance == ""){
              return "Please enter an abundance for reaction " + (i+1) + ". If unknown enter ?";
            }
          }
        }
        return "Submission OK";
      }

      function unifyPublications() {
        if (reactions.length === 0) {
          return;
        }
        const firstPublication = "" + reactions[0].publication;
        const firstDoi = "" + reactions[0].publicationdoi;
        console.log("Unifying to:", firstPublication, firstDoi);
        const updatedReactions = reactions.map((reaction) => ({
            ...reaction,
            publication: firstPublication,
            publicationdoi: firstDoi
        }));
        console.log("Before unifying:", updatedReactions);
        setReactions(updatedReactions);
        console.log("After unifying:", reactions);
      }

      function unifyConditiontags() {
        if (reactions.length === 0) {
          return;
        }
        const firstTags = "" + reactions[0].conditionTags;
        console.log("Unifying to:", firstTags);
        const updatedReactions = reactions.map((reaction) => ({
            ...reaction,
            conditionTags: firstTags
        }));
        console.log("Before unifying:", updatedReactions);
        setReactions(updatedReactions);
        console.log("After unifying:", reactions);
      }

      const count_chars = (s) => {
    const map = new Map();
    for (const char of s) {
        map.set(char, (map.get(char) || 0) + 1);
    }
    return map;
};

      function getTypeAndClassForSubstrate(substrate, product) {
        const substrateCounts = count_chars(substrate);
        const productCounts = count_chars(product);
        let type = null;
        if (substrateCounts.get('C') >= 5 && substrateCounts.get('C') < 10) {
          type = "hemi";
        } else if (substrateCounts.get('C') >= 10 && substrateCounts.get('C') < 15) {
          type = "mono";
        } else if (substrateCounts.get('C') >= 15 && substrateCounts.get('C') < 20) {
          type = "sesq";
        } else if (substrateCounts.get('C') >= 20 && substrateCounts.get('C') < 25) {
          type = "di";
        } else if (substrateCounts.get('C') >= 25 && substrateCounts.get('C') < 30) {
          type = "sester";
        } else if (substrateCounts.get('C') >= 30 && substrateCounts.get('C') < 35) {
          type = "tri";
        } else if (substrateCounts.get('C') >= 35 && substrateCounts.get('C') < 40) {
          type = "sesquar"
        } else if (substrateCounts.get('C') >= 40) {
          type = "tetra"
        } else {
          type = null;
        }
        let reactionClass = null;
        // If there is no phosphor in the product and there is one in the substrate it is class 1
        if (!product.includes('P') && substrate.includes('P')) {
          reactionClass = "1";
        } //If there is no phosphor in the reaction it is most probably a class 2 reaction
        else if (!product.includes('P') && !substrate.includes('P')) {
          reactionClass = "2";
        } //Phosphor in both is difficult - could be class 2, could be a pt 
        else if (product.includes('P') && substrate.includes('P')) {
          if (substrateCounts.get('C') < productCounts.get('C')) {
            reactionClass = null; //Could be pt
            type = "pt";
          } else {
            reactionClass = "2";
          }
        } else if (product.includes('P') && !substrate.includes('P')) {
          reactionClass = null;
          console.warn("Phosphor appears during reaction - weird for TPS");
        }
        return { type, class: reactionClass };
      }

      function autoDetectTypeAndClass() {
        if (reactions.length === 0) {
          return;
        }
        const updatedReactions = reactions.map((reaction) => {
            if (!reaction.is_new) {
                return reaction; // Skip existing reactions
            }
            const { type, class: reactionClass } = getTypeAndClassForSubstrate(reaction.substrates[0].smiles, reaction.product_mol.smiles);
            return {
                ...reaction,
                type: type || reaction.type,
                class: reactionClass || reaction.class
            };
        });

        setReactions(updatedReactions);
      }

      function transformDataForSubmission(formEnzymeData, reactions) {
        return reactions.filter(reaction => reaction.is_new).map(reaction => {
            const substrates = reaction.substrates.map(sub => ({
                name: sub.name,
                smiles: sub.smiles,
                chebi: sub.chebi,
                marts: sub.marts,
                stereochemistry: sub.stereochemistry
            }));
            let username = "Unregistered";
            if (auth && auth.username) {
                username = auth.username;
            }
            
            return {
                Enzyme_marts_ID: formEnzymeData.martsId,
                Uniprot_ID: formEnzymeData.uniprotId,
                Genbank_ID: formEnzymeData.genbankId,
                Enzyme_name: formEnzymeData.enzymeName,
                Aminoacid_sequence: formEnzymeData.aminoacidSequence,
                Species: formEnzymeData.species,
                Kingdom: formEnzymeData.kingdom,
                Type: reaction.type,
                Class: reaction.class,
                Substrate_name: substrates.map(sub => sub.name).join(';'),
                Substrate_smiles: Buffer.from(substrates.map(sub => sub.smiles).join(';')),
                Substrate_chebi_ID: substrates.map(sub => sub.chebi).join(';'),
                Substrate_marts_ID: substrates.map(sub => sub.marts).join(';'),
                Substrate_stereochemistry: substrates.map(sub => sub.stereochemistry).join(';'),
                Product_name: reaction.product_mol.name,
                Product_smiles: Buffer.from(reaction.product_mol.smiles),
                Product_chebi_ID: reaction.product_mol.chebi,
                Product_marts_ID: reaction.product_mol.marts,
                Product_stereochemistry: reaction.product_mol.stereochemistry,
                Reaction_has_mechanism: reaction.mechanism_marts ? true : false,
                Publication: reaction.publication,
                Publication_DOI: reaction.publicationdoi,
                Mechanism_marts_ID: reaction.mechanism_marts,
                tags: reaction.conditionTags,
                User: username,
                abundance: reaction.abundance

            };
        });
    }

    function transformMechanismDataForSubmission(formEnzymeData, reactions) {
      function getEnzymeId(enzymeData) {
        return enzymeData.martsId || enzymeData.uniprotId || enzymeData.genbankId || "";
    }

    let steps = [];
    let mechanism_identifier = maxMechanismSubmissions;
    let username = "Unregistered";
            if (auth && auth.username) {
                username = auth.username;
            }
    reactions.forEach(reaction => {
        if (reaction.mechanism && reaction.mechanism.length > 0) {
          mechanism_identifier++;
            let enzyme_id = getEnzymeId(formEnzymeData);
            let substrate = reaction.substrates[0];
            let product = reaction.product_mol;
            let prevMolecule = substrate;
            
            reaction.mechanism.forEach(step => {
                let nextMolecule = step.molecule;
                
                steps.push({
                    enzyme_id,
                    substrate_smiles: Buffer.from(prevMolecule.smiles),
                    substrate_name: prevMolecule.name,
                    substrate_chebi_ID: prevMolecule.chebi,
                    substrate_marts_ID: prevMolecule.marts,
                    substrate_stereochemistry: prevMolecule.stereochemistry,
                    product_smiles: Buffer.from(nextMolecule.smiles),
                    product_name: nextMolecule.name,
                    product_chebi_ID: nextMolecule.chebi,
                    product_marts_ID: nextMolecule.marts,
                    product_stereochemistry: nextMolecule.stereochemistry,
                    mechanism_type: step.mechanism,
                    mechanism_publication: reaction.mechanism_publication,
                    mechanism_publication_DOI: reaction.mechanism_doi,
                    mechanism_evidence: step.evidence,
                    mechanism_identifier: mechanism_identifier,
                    User: username
                });
                
                prevMolecule = nextMolecule;
            });
            
            steps.push({
                enzyme_id,
                substrate_smiles: Buffer.from(prevMolecule.smiles),
                substrate_name: prevMolecule.name,
                substrate_chebi_ID: prevMolecule.chebi,
                substrate_marts_ID: prevMolecule.marts,
                substrate_stereochemistry: prevMolecule.stereochemistry,
                product_smiles: Buffer.from(product.smiles),
                product_name: product.name,
                product_chebi_ID: product.chebi,
                product_marts_ID: product.marts,
                product_stereochemistry: product.stereochemistry,
                mechanism_type: reaction.final_mech_step,
                mechanism_publication: reaction.mechanism_publication,
                mechanism_publication_DOI: reaction.mechanism_doi,
                mechanism_evidence: reaction.final_mech_evidence,
                mechanism_identifier: mechanism_identifier,
                User: username
            });
        }
    });
    
    return steps;
    }

      async function submitEntry() {
        const check = checkIfSubmissionOk();
        if (check == "Submission OK"){
          const submissions = transformDataForSubmission(formEnzymeData, reactions);
          
          const mechanismSubmissions = transformMechanismDataForSubmission(formEnzymeData, reactions);
          console.log(mechanismSubmissions);
          setSubmitMessage("Submission OK");
          for (let i = 0; i < submissions.length; i++){
            console.log(submissions[i]);
            await axios.post("/submitentry", submissions[i]);
          }
          for (let i = 0; i < mechanismSubmissions.length; i++){
            console.log(mechanismSubmissions[i]);
            await axios.post("/submitentry", mechanismSubmissions[i]);
          }
          navigate("/successsubmit")
        }
        else{
          setSubmitMessage(check);
        }
      }
    
      return (
        <div id="statsbody">
        <HomeNavbar />
        <div id="basicpage">
          <StatsBox title="Enzyme">
            <StatsBox title="Identifiers" backgroundColor="RGB(250,250,250)">
              <p>Enter a unique identifier for your enzyme. If the enzyme already exists the information will be filled in.</p>
          <SubmitInputField name="uniprotId" value={formEnzymeData.uniprotId} onChange={handleInputChange} label="Uniprot ID" tooltip="Uniprot ID is the prefered identifier for enzymes in marts. If the sequence is deposited only in Uniparc that ID can be used here." placeholder="Q41594" />
          <SubmitInputField name="genbankId" value={formEnzymeData.genbankId} onChange={handleInputChange} label="Genbank ID" tooltip="For enzymes that do not have Uniprot entry, genbank id can be used." placeholder="XP_055691875.1"/>
          <SubmitInputField name="martsId" value={formEnzymeData.martsId} onChange={handleInputChange} label="Marts ID" tooltip="Enzymes already in MARTS have Marts ID, fill in only if you want to update information about known enzyme." placeholder="marts_E00023" />
            </StatsBox>
            <StatsBox title="Detail fields" backgroundColor="RGB(250,250,250)">
              <p>Enter additional information about the enzyme.</p>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', alignItems: 'center' }}>
          <SubmitInputField name="enzymeName" value={formEnzymeData.enzymeName} onChange={handleInputChange} label="Enzyme Name" tooltip="Enzyme name should be a very short description. Does not have to be unique." placeholder="Taxadiene synthase"/>
          <SubmitInputField name="aminoacidSequence" value={formEnzymeData.aminoacidSequence} onChange={handleInputChange} label="Amino Acid Sequence" placeholder="MGKIVEKSVLFEEVLVELKEFAALQKCDTEYLERMLRYHNENIFGGILYLD" tooltip="Fill in the full aminoacid sequence of the enzyme."/>         
          <SubmitCreatableSelect label={"Kingdom"} options={kingdoms} onChange={handleInputChange} placeholder="Animalia (Coral)" target="kingdom" value={{value: formEnzymeData.kingdom, label: formEnzymeData.kingdom}}/>
            <SubmitInputField name="species" value={formEnzymeData.species} onChange={handleInputChange} label="Species" tooltip="The latin name of the species this enzyme comes from." placeholder="Arabidopsis thaliana"/>
            </div>
            </StatsBox>
          </StatsBox>

          <StatsBox title="Reactions">
            <p>Define reactions catalyzed by your enzyme.</p>
          {reactions.map((reaction, index) => (
        <ReactionForm
          key={index}
          reaction={reaction}
          onChange={(updatedReaction) => handleReactionChange(index, updatedReaction)}
          setMechanismBody={setMechanismBody}
          mechanismTypes={mechanismStepTypes}
          evidenceTypes={evidenceTypes}
          knownConditionTags={knownConditionTags}
          sessionMechanismSources={getSessionMechanismSources(index)}
        />
      ))}
      
        <div className="button-container">
          <div>
          <button
          class = "basic-button"
          onClick={addReaction}
          >
          Add Reaction
        </button>
        <button
          class = "basic-button"
          onClick={removeReaction}
          disabled={reactions.length === 0 || reactions[reactions.length - 1].is_new === false}
          >
          Remove Reaction
        </button>
        </div>     
        </div>
         <div className="button-container">
          <div>
         <button
          class = "basic-button"
          onClick={unifyPublications}
          >
          <nobr> Unify publications by first</nobr>
        </button>
         <button
          class = "basic-button"
          onClick={autoDetectTypeAndClass}
          >
          <nobr> Auto detect type and class</nobr>
        </button>
          <button
          class = "basic-button"
          onClick={unifyConditiontags}
          >
          <nobr> Unify condition tags by first</nobr>
        </button>
        </div>     
        </div>
          </StatsBox>
          <div className="button-container">
          <div>
          </div> 
             {SubmitMessage}
        <button
          class = "basic-button"
          onClick={submitEntry}
          >
          <nobr> <FontAwesomeIcon icon={faCheck} /> Submit Entry</nobr>
        </button> 
          </div>
          
        </div>
        <Footer />
<MechanismWindow>
<MechanismTable
  heading={[
    "Intermediate substrate",
    "Intermediate product",
    "Mechanism type",
  ]}
  body={mechanismBody}
/>
</MechanismWindow>
    </div>




      );


}


export default SubmitPage;